/**
 * Enterprise sales contact page (Expo route `app/enterprise.tsx`).
 * Used by pricing cards instead of the non-existent `/contact` app route.
 */
export const ENTERPRISE_CONTACT_PATH = '/enterprise' as const
